export enum Typography {
  Heading    = "Heading",
  Subheading = "Subheading",
  Title      = "Title",
  Subtitle   = "Subtitle",
  Body       = "Body",
  Caption    = "Caption",
  Small      = "Small",
}
